import { ValueType } from 'realgrid'
export const clientStockfields = [
    {fieldName: 'ownerKey', dataType: ValueType.TEXT},
    {fieldName: 'custCd', dataType: ValueType.TEXT},
    {fieldName: 'custNm', dataType: ValueType.TEXT},
    {fieldName: 'stcKey', dataType: ValueType.TEXT},
    {fieldName: 'itemCd', dataType: ValueType.TEXT},
    {fieldName: 'itemNm', dataType: ValueType.TEXT},
    {fieldName: 'lot1', dataType: ValueType.TEXT},
    {fieldName: 'lot2', dataType: ValueType.TEXT},
    {fieldName: 'lot3', dataType: ValueType.TEXT},
    {fieldName: 'lot4', dataType: ValueType.TEXT},
    {fieldName: 'lot5', dataType: ValueType.TEXT},
    {fieldName: 'lot6', dataType: ValueType.TEXT},
    {fieldName: 'lot7', dataType: ValueType.TEXT},
    {fieldName: 'qty', dataType: ValueType.TEXT}
  ]
  export const clientStockColumns = [
    {
      name: 'ownerKey',
      fieldName: 'ownerKey',
      type: 'data',
      width: '50',
      styleName: "rg-align-center",
      header: {
          text: '화주코드',
          showTooltip: false
      },
      visible: false
    },
    {
      name: 'custCd',
      fieldName: 'custCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
          text: '거래처코드',
          showTooltip: false
      }
    },
    {
      name: 'custNm',
      fieldName: 'custNm',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: {
          text: '거래처명',
          showTooltip: false
      },
      visible: true
    },
    {
      name: 'stcKey',
      fieldName: 'stcKey',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
          text: '재고KEY',
          showTooltip: false
      },
      visible: false
    },
    {
      name: 'itemCd',
      fieldName: 'itemCd',
      type: 'data',
      width: '50',
      styleName: "rg-align-center",
      header: { 
          text: '제품코드',
          showTooltip: false
      },
      visible: false
    },
    {
      name: 'itemNm',
      fieldName: 'itemNm',
      type: 'data',
      width: '150',
      styleName: "rg-align-left",
      header: {
          text: '제품명',
          showTooltip: false
      }
    },
    {
      name: 'lot1',
      fieldName: 'lot1',
      type: 'data',
      width: '50',
      styleName: "rg-align-center",
      header: { 
          text: 'BATCH',
          showTooltip: false
      }
    },
    {
      name: 'lot2',
      fieldName: 'lot2',
      type: 'data',
      width: '200',
      styleName: "rg-align-center",
      header: { 
          text: '유효기간',
          showTooltip: false
      }
    },
    {
      name: 'lot3',
      fieldName: 'lot3',
      type: 'data',
      width: '200',
      styleName: "rg-align-center",
      header: { 
          text: 'SERIAL',
          showTooltip: false
      }
    },
    {
      name: 'lot4',
      fieldName: 'lot4',
      type: 'data',
      width: '200',
      styleName: "rg-align-center",
      header: { 
          text: '제조일자',
          showTooltip: false
      }
    },
    {
      name: 'lot5',
      fieldName: 'lot5',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: { 
          text: '여유필드1',
          showTooltip: false
      },
      visible : false
    },
    {
      name: 'lot6',
      fieldName: 'lot6',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: { 
          text: '여유필드2',
          showTooltip: false
      },
      visible : false
    },
    {
      name: 'lot7',
      fieldName: 'lot7',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: { 
          text: '여유필드3',
          showTooltip: false
      },
      visible : false
    },
    {
      name: 'qty',
      fieldName: 'qty',
      type: 'data',
      width: '80',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '수량',
          showTooltip: false
      }
    }
  ]